// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


// require('jquery')
// import Rails from "@rails/ujs"
// import Turbolinks from "turbolinks"
// import * as ActiveStorage from "@rails/activestorage"
// import "channels"
// import $ from 'jquery'

// Rails.start()
// Turbolinks.start()
// ActiveStorage.start()


// No hace falta añadir Popper o jQuery aquí porque Bootstrap los llamará internamente
require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require('bootstrap')
require('bootstrap-datepicker')
require("@fortawesome/fontawesome-free/js/all")
require("@nathanvda/cocoon")
// Custom JS
require('packs/registration')
require('packs/edit_stockholder')
require('packs/search_stockstockholder')
require('packs/new_assembly')
require('packs/reports')
require('packs/visor_contraseña')

$(document).on("turbolinks:load", function () {
    components_ready();
    let browser = fnBrowserDetect();  
    module.exports = {browser};
    showModal();
    showSpinner();
    enable_button();
    truncate_document_string();
});

$.fn.datepicker.dates['es'] = {
    days: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sab"],
    daysMin: ["D", "L", "M", "X", "J", "V", "S"],
    months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    today: "Hoy",
    clear: "Limpiar",
    format: "dd/mm/yyyy",
    titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
    weekStart: 0
};

function fnBrowserDetect(){
                 
    let userAgent = navigator.userAgent;
    let browserName;
    
    if(userAgent.match(/chrome|chromium|crios/i)){
        browserName = "chrome";
      }else if(userAgent.match(/firefox|fxios/i)){
        browserName = "firefox";
      }  else if(userAgent.match(/safari/i)){
        browserName = "safari";
      }else if(userAgent.match(/opr\//i)){
        browserName = "opera";
      } else if(userAgent.match(/edg/i)){
        browserName = "edge";
      }else{
        browserName="No browser detection";
      }
      return browserName;
}

function components_ready(){
    let date = new Date()
    let month = date.getMonth() == 11 ? 0 : date.getMonth() + 1
    let year = month == 0 ? date.getFullYear() + 1 : date.getFullYear()
    $('.calendar-full-month').datepicker({
        format: 'dd-mm-yyyy',
        endDate: new Date(year, month, 0), // Asi seleccionamos hasta el último día del mes
        language: 'es',
    })

    $('.calendar').datepicker({
        format: 'dd-mm-yyyy',
        endDate: '-1d',
        language: 'es',
    });

    $('.assembly-calendar').datepicker({
        format: 'dd/mm/yyyy',
        startDate: '+1d',
        language: 'es',
        daysOfWeekDisabled: '0,6',
    });

    $('.report-calendar').datepicker({
      format: 'dd-mm-yyyy',
      endDate: '-1d',
      startDate: new Date('2022-04-13'), // Día inicial 12-04-2022
      daysOfWeekDisabled: '0,6',
      language: 'es',
  });

    // Tipos habilitados para descargar el reporte del día actual.
    // Mantener sincronizado con ON_DEMAND_REPORT_TYPES del AdminController.
    var REPORT_SAME_DAY_TYPES = ['IAC', 'Bancaribe'];

    // Devuelve la fecha de hoy en formato dd-mm-yyyy (igual al del datepicker).
    function reportCalendarTodayStr() {
      var d = new Date();
      var dd = ('0' + d.getDate()).slice(-2);
      var mm = ('0' + (d.getMonth() + 1)).slice(-2);
      return dd + '-' + mm + '-' + d.getFullYear();
    }

    // Ajusta la fecha máxima seleccionable del datepicker según el tipo de
    // accionista: hoy ('0d') para tipos same-day, ayer ('-1d') para el resto.
    // Si se cambia a un tipo que NO permite el día actual y la fecha elegida
    // era justamente hoy (único valor que puede quedar fuera de rango), se limpia.
    function updateReportCalendarEndDate() {
      var type = $('#report_type_stockholder').val();
      var isSameDay = REPORT_SAME_DAY_TYPES.indexOf(type) !== -1;
      var $cal = $('.report-calendar');

      $cal.datepicker('setEndDate', isSameDay ? '0d' : '-1d');

      if (!isSameDay && $cal.val() === reportCalendarTodayStr()) {
        $cal.datepicker('clearDates');
      }
    }

    $('#report_type_stockholder').on('change', updateReportCalendarEndDate);
    updateReportCalendarEndDate();

    $('.poll-calendar').datepicker({
      format: 'dd-mm-yyyy',
      startDate: new Date(), 
      daysOfWeekDisabled: '0,6',
      endDate: "+1y",
      language: 'es'
    })
}

const showModal = () => {
  if ($("#exampleModal").length > 0){
      $("#exampleModal").modal('show')
  }
}

const showSpinner = () => {
  const form = document.querySelector('form');
  if (!form) return;
  form.addEventListener('submit', function(event) {
  document.getElementById('spinner').style.display = 'block';
  });
}

const truncate_document_string = () => {
  const assemblyDocument = document.getElementById("assembly_document");
  if (!assemblyDocument) return;
  assemblyDocument.addEventListener("change", function() {
    var fileName = this.files[0].name;
    if (fileName.length > 30) {
      fileName = fileName.substring(0, 30) + '...';
    }
    document.querySelector(".file-name").textContent = fileName;
  });
}

const enable_button = () => {
  const assemblyDocument = document.querySelector("#assembly_document");
  if (!assemblyDocument) return;
  assemblyDocument.addEventListener("change", function() {
    document.querySelector("#submit-button").removeAttribute("disabled");
  });
}

// No scroll cuando recargo la página
$(window).on("scroll",function () {
    sessionStorage.scrollTop = $(this).scrollTop();
});
$(document).on("ready",function () {
    if (sessionStorage.scrollTop != "undefined") {
        $(window).scrollTop(sessionStorage.scrollTop);
    }
});

// Barra de Progreso para carga de archivos
addEventListener("direct-upload:initialize", event => {
  const { target, detail } = event
  const { id, file } = detail
  target.insertAdjacentHTML("beforebegin", `
    <div id="direct-upload-${id}" class="direct-upload direct-upload--pending">
      <div id="direct-upload-progress-${id}" class="direct-upload__progress" style="width: 0%"></div>
      <span class="direct-upload__filename text-dark fw-bold">${file.name}</span>
    </div>
  `)
  $("#paperclip").hide()
})
addEventListener("direct-upload:start", event => {
  const { id } = event.detail
  const element = document.getElementById(`direct-upload-${id}`)
  element.classList.remove("direct-upload--pending")
})
addEventListener("direct-upload:progress", event => {
  const { id, progress } = event.detail
  const progressElement = document.getElementById(`direct-upload-progress-${id}`)
  progressElement.style.width = `${progress}%`
})
addEventListener("direct-upload:error", event => {
  event.preventDefault()
  const { id, error } = event.detail
  const element = document.getElementById(`direct-upload-${id}`)
  element.classList.add("direct-upload--error")
  element.setAttribute("title", error)
})
addEventListener("direct-upload:end", event => {
  const { id } = event.detail
  const element = document.getElementById(`direct-upload-${id}`)
  element.classList.add("direct-upload--complete")
})

// Sondeo (polling) del estado de los reportes del día generados en background.
// Por cada recuadro .report-status-box[data-poll='true'] (solicitud en curso), consulta el
// endpoint de estado cada pocos segundos y, al completarse, muestra su botón de descarga.
// El `;` inicial evita que esta IIFE se una a la sentencia previa (que no termina en ;).
;(function () {
  var REPORT_POLL_INTERVAL_MS = 5000;
  var reportPollTimers = [];

  function stopReportPolling() {
    reportPollTimers.forEach(function (timer) { clearInterval(timer); });
    reportPollTimers = [];
  }

  function pollReportStatus(box, timerRef) {
    var statusUrl  = box.dataset.statusUrl;
    var messageEl  = box.querySelector(".report-status-message");
    var downloadEl = box.querySelector(".report-download-container");

    fetch(statusUrl, { headers: { "Accept": "application/json" }, credentials: "same-origin" })
      .then(function (response) {
        // Sesión expirada (timeout de Devise): dejamos de sondear; un refresh re-autentica.
        if (response.status === 401) {
          clearInterval(timerRef.id);
          messageEl.className = "alert alert-warning text-center report-status-message";
          messageEl.textContent = "Tu sesión expiró. Refresca la página para ver el estado del reporte.";
          return null;
        }
        if (!response.ok) { return null; } // otro error transitorio: reintenta en el próximo intervalo
        return response.json();
      })
      .then(function (data) {
        if (!data) { return; }
        if (data.status === "completed" && data.download_url) {
          clearInterval(timerRef.id);
          messageEl.className = "alert alert-success text-center report-status-message";
          messageEl.textContent = "¡Tu reporte está listo!";
          var fname = (data.filename || "reporte.xlsx").replace(/"/g, "");
          downloadEl.innerHTML =
            '<a class="btn btn-primary border-r-20" href="' + data.download_url + '" data-filename="' + fname + '">Descargar reporte</a>';
        } else if (data.status === "failed") {
          clearInterval(timerRef.id);
          messageEl.className = "alert alert-danger text-center report-status-message";
          messageEl.textContent = data.error_message || "No se pudo generar el reporte. Intente nuevamente.";
        }
      })
      .catch(function () { /* error transitorio de red: se reintenta en el próximo intervalo */ });
  }

  function initReportPolling() {
    stopReportPolling();
    var boxes = document.querySelectorAll(".report-status-box");
    boxes.forEach(function (box) {
      // Solo sondeamos los recuadros en curso (los que muestran el spinner). Los ya listos
      // o fallidos ya vienen renderizados desde el servidor y no necesitan sondeo.
      if (!box.querySelector(".spinner-border")) { return; }

      var timerRef = {};
      pollReportStatus(box, timerRef);
      timerRef.id = setInterval(function () { pollReportStatus(box, timerRef); }, REPORT_POLL_INTERVAL_MS);
      reportPollTimers.push(timerRef.id);
    });
  }

  // Al pulsar "Descargar": mostramos un spinner en el botón, traemos el archivo vía fetch (el back
  // puede tardar en responder), disparamos la descarga y ocultamos el recuadro. Delegado en document
  // → se registra una sola vez y cubre tanto los botones del servidor como los creados por el sondeo.
  $(document).on("click", ".report-download-container a", function (e) {
    e.preventDefault();
    var $link = $(this);
    if ($link.data("downloading")) { return; } // evita doble clic
    $link.data("downloading", true);

    var $box        = $link.closest(".report-status-box");
    var url         = $link.attr("href");
    var filename    = $link.data("filename") || "reporte.xlsx";
    var originalHtml = $link.html();

    $link.addClass("disabled").attr("aria-disabled", "true")
         .html('<span class="spinner-border spinner-border-sm me-2" role="status"></span>Descargando...');

    fetch(url, { credentials: "same-origin" })
      .then(function (resp) {
        if (!resp.ok) { throw new Error("Descarga fallida (" + resp.status + ")"); }
        return resp.blob();
      })
      .then(function (blob) {
        var objectUrl = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = objectUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(objectUrl);
        $box.remove(); // el reporte ya se descargó → ocultamos el recuadro
      })
      .catch(function () {
        // restauramos el botón para permitir reintento
        $link.removeClass("disabled").removeAttr("aria-disabled")
             .html(originalHtml).data("downloading", false);
        alert("No se pudo descargar el reporte. Intenta de nuevo.");
      });
  });

  $(document).on("turbolinks:load", initReportPolling);
  $(document).on("turbolinks:before-visit", stopReportPolling);
})();